import TransactionDynamicField from "../TransactionDynamicField/TransactionDynamicField";
import { useTheme } from "@mui/material/styles";
import { TransactionDTO } from "../../../models/transactions";

import { BookingsAmountContainer, BookingsContainer, ScreenTwoContainer } from "./styles";

import { useMemo } from "react";

interface Props {
  transaction: TransactionDTO;
  handleChangeField: (field: keyof TransactionDTO, value: TransactionDTO[keyof TransactionDTO]) => void;
  defaultTransaction?: TransactionDTO | null;
}

const TransactionScreenTwo = ({ transaction, handleChangeField, defaultTransaction }: Props) => {
  const theme = useTheme();
  const sortedFields = transaction.type?.fieldsConfigs?.sort((a, b) => a.sequence - b.sequence);

  const bankAndCashAccounts: string[] =
    transaction.type?.fieldsConfigs
      ?.filter(
        (el) =>
          el.fieldName === "FromWhichBankAccount" ||
          el.fieldName === "FromWhichCashAccount" ||
          el.fieldName === "ToWhichCashAccount" ||
          el.fieldName === "ToWhichBankAccount"
      )
      .map((el) => el.fieldName) ?? [];

  const firstPaymentAcc = bankAndCashAccounts.length !== 0 ? bankAndCashAccounts[0] : "WithoutBank";

  const assetsAmount = useMemo(() => {
    return transaction.assets?.map((asset) => +asset.amount).reduce((acc, curr) => acc + curr, 0) ?? 0;
  }, [transaction.assets]);

  const loansAmount = useMemo(() => {
    return transaction.loans?.map((loan) => +loan.amount).reduce((acc, curr) => acc + curr, 0) ?? 0;
  }, [transaction.loans]);
  const revenuesAmount = useMemo(() => {
    return transaction.revenues?.map((revenue) => +revenue.amount).reduce((acc, curr) => acc + curr, 0) ?? 0;
  }, [transaction.revenues]);
  const expensesAmount = useMemo(() => {
    return transaction.expenses?.map((expense) => +expense.amount).reduce((acc, curr) => acc + curr, 0) ?? 0;
  }, [transaction.expenses]);
  const donatorAmount = useMemo(() => {
    return (
      transaction.attributionsOfTheReceivedDonation
        ?.map((donation) => +donation.amount)
        .reduce((acc, curr) => acc + curr, 0) ?? 0
    );
  }, [transaction.attributionsOfTheReceivedDonation]);

  const vatClientCountryAmount = useMemo(() => {
    return transaction.clientInvoice?.vatBases?.map((vat) => +vat.amount).reduce((acc, curr) => acc + curr, 0) ?? 0;
  }, [transaction.clientInvoice?.vatBases]);
  const vatVendorCountryAmount = useMemo(() => {
    return transaction.vendorInvoice?.vatBases?.map((vat) => +vat.amount).reduce((acc, curr) => acc + curr, 0) ?? 0;
  }, [transaction.vendorInvoice?.vatBases]);

  const finalAmount =
    assetsAmount +
    loansAmount +
    revenuesAmount +
    expensesAmount +
    donatorAmount +
    vatClientCountryAmount +
    vatVendorCountryAmount;

  return (
    <ScreenTwoContainer>
      {sortedFields?.map(({ fieldName, id }) => (
        <TransactionDynamicField
          key={id}
          transaction={transaction}
          dynamicField={fieldName}
          handleChangeField={handleChangeField}
          firstPaymentAcc={firstPaymentAcc}
          bankAndCashAccounts={bankAndCashAccounts}
          defaultTransaction={defaultTransaction}
        />
      ))}

      <BookingsContainer>
        <span>BOOKINGS:</span>
        <BookingsAmountContainer>
          <span>Total:</span>
          <span
            style={{
              color: +transaction.amount === +finalAmount ? theme.palette.success.main : theme.palette.error.main,
            }}
          >
            {(+finalAmount).toLocaleCustom()}
          </span>
          <span
            style={{
              color: +transaction.amount === +finalAmount ? theme.palette.success.main : theme.palette.error.main,
            }}
          >
            {transaction.currency?.code}
          </span>
        </BookingsAmountContainer>
      </BookingsContainer>
    </ScreenTwoContainer>
  );
};

export default TransactionScreenTwo;
